import { Group } from '@ms/yammer-data/dist/state/types';
import { groupFilesPage } from '@ms/yammer-web-support/dist/urls';

import { useBaseHost } from '../session';

type UseExternalGroupFilesUrl = (groupId: Group['id']) => string;
export const useExternalGroupFilesUrl: UseExternalGroupFilesUrl = (groupId) => {
  const baseHost = useBaseHost();

  return `${baseHost}${groupFilesPage(groupId)}`;
};
